// Function to fetch sheet data
export const fetchSheetData = async (): Promise<SheetsData> => {
  try {
    //http://localhost:3031
    const response = await fetch('/api/sheet-data');
    const data: SheetsData = await response.json();

    // Return the fetched data
    return data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error; // Rethrow the error to handle it in the calling function
  }
};
